import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import gameService from './gameService';
import { setAlertError, setAlertInfo } from '../alert/alertSlice';

export const getAllGames = createAsyncThunk('game/getAllGames', async (data, thunkAPI) => {
  return await gameService
    .get()
    .then((response) => {
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const getGameById = createAsyncThunk('game/getGameById', async (data, thunkAPI) => {
  return await gameService
    .getById(data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const getGameByEventId = createAsyncThunk(
  'game/getGameByEventId',
  async (data, thunkAPI) => {
    return await gameService
      .getByEventId(data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

export const getGameBySectionId = createAsyncThunk(
  'game/getGameBySectionId',
  async (data, thunkAPI) => {
    return await gameService
      .getBySectionId(data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

export const getGamesByUserId = createAsyncThunk(
  'game/getGamesByUserId',
  async (data, thunkAPI) => {
    return await gameService
      .getByUserId()
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

export const getGamesByScorer = createAsyncThunk('game/getGamesByScorer', async (_, thunkAPI) => {
  return await gameService
    .getByScorer()
    .then((response) => {
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const createGame = createAsyncThunk('game/createGame', async (data, thunkAPI) => {
  return await gameService
    .create(data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const updateGame = createAsyncThunk('game/updateGame', async (data, thunkAPI) => {
  return await gameService
    .update(data.id, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const deleteGame = createAsyncThunk('game/deleteGame', async (data, thunkAPI) => {
  return await gameService
    .remove(data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const startGame = createAsyncThunk('game/startGame', async (data, thunkAPI) => {
  return await gameService.startGame(data).then((response) => {
    return response;
  });
});

export const scoreGame = createAsyncThunk('game/scoreGame', async (data, thunkAPI) => {
  return await gameService.scoreGame(data).then((response) => {
    return response;
  });
});

export const undoLastScore = createAsyncThunk('game/undoLastScore', async (data, thunkAPI) => {
  return await gameService.undoLastScore(data).then((response) => {
    return response;
  });
});

export const publicStartGame = createAsyncThunk('game/publicStartGame', async (data, thunkAPI) => {
  return await gameService.publicStartGame(data).then((response) => {
    return response;
  });
});

export const publicScoreGame = createAsyncThunk('game/publicScoreGame', async (data, thunkAPI) => {
  return await gameService.publicScoreGame(data).then((response) => {
    return response;
  });
});

export const publicUndoLastScore = createAsyncThunk(
  'game/publicUndoLastScore',
  async (data, thunkAPI) => {
    return await gameService.publicUndoLastScore(data).then((response) => {
      return response;
    });
  }
);

export const startNewSet = createAsyncThunk('game/startNewSet', async (data, thunkAPI) => {
  return await gameService.startNewSet(data).then((response) => {
    return response;
  });
});

export const startPlayoff = createAsyncThunk('game/startPlayoff', async (data, thunkAPI) => {
  return await gameService.startPlayoff(data).then((response) => {
    return response;
  });
});

export const scorePlayoffGame = createAsyncThunk(
  'game/scorePlayoffGame',
  async (data, thunkAPI) => {
    return await gameService.scorePlayoffGame(data).then((response) => {
      return response;
    });
  }
);

export const undoPlayoffScore = createAsyncThunk(
  'game/undoPlayoffScore',
  async (data, thunkAPI) => {
    return await gameService.undoPlayoffScore(data).then((response) => {
      return response;
    });
  }
);

export const inputSetScore = createAsyncThunk('game/inputSetScore', async (data, thunkAPI) => {
  return await gameService.inputSetScore(data).then((response) => {
    return response;
  });
});

export const assignScorer = createAsyncThunk('game/assignScorer', async (data, thunkAPI) => {
  return await gameService
    .assignScorer(data)
    .then((response) => {
      thunkAPI.dispatch(setAlertInfo('User invite sent.'));
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      thunkAPI.dispatch(setAlertError(err));
      return thunkAPI.rejectWithValue(err);
    });
});

export const assignMySelf = createAsyncThunk('game/assignMySelf', async (data, thunkAPI) => {
  return await gameService
    .assignMySelf(data)
    .then((response) => {
      thunkAPI.dispatch(setAlertInfo('You are now assigned as the scorer.'));
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      thunkAPI.dispatch(setAlertError(err));
      return thunkAPI.rejectWithValue(err);
    });
});

export const removeScorer = createAsyncThunk('game/removeScorer', async (data, thunkAPI) => {
  return await gameService
    .removeScorer(data)
    .then((response) => {
      thunkAPI.dispatch(setAlertInfo('Scorer was removed.'));
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      thunkAPI.dispatch(setAlertError(err));
      return thunkAPI.rejectWithValue(err);
    });
});

export const saveScorecardPhoto = createAsyncThunk(
  'game/saveScorecardPhoto',
  async (data, thunkAPI) => {
    return await gameService
      .saveScorecardPhoto(data)
      .then((response) => {
        thunkAPI.dispatch(setAlertInfo('Scorecard photo saved.'));
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        thunkAPI.dispatch(setAlertError(err));
        return thunkAPI.rejectWithValue(err);
      });
  }
);

export const generateGames12LogBased = createAsyncThunk(
  'game/generateGames12LogBased',
  async (data, thunkAPI) => {
    return await gameService
      .generateGames12LogBased(data)
      .then((response) => {
        thunkAPI.dispatch(setAlertInfo('Games generated successfully.'));
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        thunkAPI.dispatch(setAlertError(err));
        return thunkAPI.rejectWithValue(err);
      });
  }
);

const gameSlice = createSlice({
  name: 'game',
  initialState: {
    games: [],
    status: 'idle',
    error: null,
    creatingGame: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllGames.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllGames.fulfilled, (state, action) => {
        state.loading = false;
        state.games = state.games.concat(action.payload);
      })
      .addCase(getAllGames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getGameById.fulfilled, (state, action) => {
        state.game = action.payload;
      })
      .addCase(getGameByEventId.fulfilled, (state, action) => {
        state.games = action.payload;
      })
      .addCase(getGameByEventId.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(getGameBySectionId.fulfilled, (state, action) => {
        state.games = action.payload;
        state.loading = false;
      })
      .addCase(getGameBySectionId.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(getGameBySectionId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGamesByUserId.fulfilled, (state, action) => {
        state.games = action.payload;
        state.loading = false;
      })
      .addCase(getGamesByUserId.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(getGamesByUserId.pending, (state) => {
        state.loadingScoringGames = true;
      })
      .addCase(getGamesByScorer.fulfilled, (state, action) => {
        state.scoringGames = action.payload;
        state.loadingScoringGames = false;
      })
      .addCase(getGamesByScorer.rejected, (state, action) => {
        state.error = action.payload;
        state.loadingScoringGames = false;
      })
      .addCase(getGamesByScorer.pending, (state) => {
        state.loading = true;
      })
      .addCase(createGame.fulfilled, (state, action) => {
        state.creatingGame = false;
        state.games.push(action.payload);
      })
      .addCase(createGame.rejected, (state, action) => {
        state.creatingGame = false;
        state.error = action.payload;
      })
      .addCase(createGame.pending, (state) => {
        state.creatingGame = true;
      })
      .addCase(updateGame.fulfilled, (state, action) => {
        const { id } = action.payload;
        let existingGame = state.games.find((game) => game.id === id);
        if (existingGame) {
          existingGame = action.payload;

          state.games = state.games.map((game) =>
            game.id === id ? { ...game, ...existingGame } : game
          );
        }
      })
      .addCase(deleteGame.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.games = state.games.filter((game) => game.id !== id);
        state.deleting = false;
      })
      .addCase(deleteGame.rejected, (state, action) => {
        state.deleting = false;
      })
      .addCase(deleteGame.pending, (state) => {
        state.deleting = true;
      })
      .addCase(startGame.fulfilled, (state, action) => {
        const updatedGame = action.payload;
        if (updatedGame) {
          const index = state.games.findIndex((game) => game.id === updatedGame.id);

          if (index !== -1) {
            state.games[index] = { ...state.games[index], ...updatedGame }; // Merge existing game properties with updated ones
          }
        }

        state.creatingGame = false;
      })
      .addCase(startGame.rejected, (state, action) => {
        state.creatingGame = false;
        state.error = action.payload;
      })
      .addCase(startGame.pending, (state) => {
        state.creatingGame = true;
      })
      .addCase(scoreGame.fulfilled, (state, action) => {
        state.scoringGame = false;
      })
      .addCase(scoreGame.rejected, (state, action) => {
        state.scoringGame = false;
        state.error = action.payload;
      })
      .addCase(scoreGame.pending, (state) => {
        state.scoringGame = true;
      })
      .addCase(undoLastScore.fulfilled, (state, action) => {
        state.undoingScore = false;
      })
      .addCase(undoLastScore.rejected, (state, action) => {
        state.undoingScore = false;
        state.error = action.payload;
      })
      .addCase(undoLastScore.pending, (state) => {
        state.undoingScore = true;
      })

      .addCase(publicStartGame.fulfilled, (state, action) => {
        const updatedGame = action.payload;
        if (updatedGame) {
          const index = state.games.findIndex((game) => game.id === updatedGame.id);

          if (index !== -1) {
            state.games[index] = { ...state.games[index], ...updatedGame }; // Merge existing game properties with updated ones
          }
        }

        state.creatingGame = false;
      })
      .addCase(publicStartGame.rejected, (state, action) => {
        state.creatingGame = false;
        state.error = action.payload;
      })
      .addCase(publicStartGame.pending, (state) => {
        state.creatingGame = true;
      })
      .addCase(publicScoreGame.fulfilled, (state, action) => {
        state.scoringGame = false;
      })
      .addCase(publicScoreGame.rejected, (state, action) => {
        state.scoringGame = false;
        state.error = action.payload;
      })
      .addCase(publicScoreGame.pending, (state) => {
        state.scoringGame = true;
      })
      .addCase(publicUndoLastScore.fulfilled, (state, action) => {
        state.undoingScore = false;
      })
      .addCase(publicUndoLastScore.rejected, (state, action) => {
        state.undoingScore = false;
        state.error = action.payload;
      })
      .addCase(publicUndoLastScore.pending, (state) => {
        state.undoingScore = true;
      })

      .addCase(startNewSet.fulfilled, (state, action) => {
        state.startingNewSet = false;
      })
      .addCase(startNewSet.rejected, (state, action) => {
        state.startingNewSet = false;
        state.error = action.payload;
      })
      .addCase(startNewSet.pending, (state) => {
        state.startingNewSet = true;
      })
      .addCase(startPlayoff.fulfilled, (state, action) => {
        state.startingPlayoff = false;
      })
      .addCase(startPlayoff.rejected, (state, action) => {
        state.startingPlayoff = false;
        state.error = action.payload;
      })
      .addCase(startPlayoff.pending, (state) => {
        state.startingPlayoff = true;
      })
      .addCase(scorePlayoffGame.fulfilled, (state, action) => {
        state.scoringGame = false;
      })
      .addCase(scorePlayoffGame.rejected, (state, action) => {
        state.scoringGame = false;
        state.error = action.payload;
      })
      .addCase(scorePlayoffGame.pending, (state) => {
        state.scoringGame = true;
      })
      .addCase(undoPlayoffScore.fulfilled, (state, action) => {
        state.undoingPlayoffScore = false;
      })
      .addCase(undoPlayoffScore.rejected, (state, action) => {
        state.undoingPlayoffScore = false;
        state.error = action.payload;
      })
      .addCase(undoPlayoffScore.pending, (state) => {
        state.undoingPlayoffScore = true;
      })
      .addCase(inputSetScore.fulfilled, (state, action) => {
        const updatedGame = action.payload;
        if (updatedGame) {
          const index = state.games.findIndex((game) => game.id === updatedGame.id);

          if (index !== -1) {
            state.games[index] = { ...state.games[index], ...updatedGame }; // Merge existing game properties with updated ones
          }
        }

        state.inputtingSetScore = false;
      })
      .addCase(inputSetScore.rejected, (state, action) => {
        state.inputtingSetScore = false;
        state.error = action.payload;
      })
      .addCase(inputSetScore.pending, (state) => {
        state.inputtingSetScore = true;
      })
      .addCase(assignScorer.fulfilled, (state, action) => {
        state.assigningScorer = false;
        state.assignResult = action.payload;
      })
      .addCase(assignScorer.rejected, (state, action) => {
        state.assigningScorer = false;
        state.assignResult = { success: false, error: action.payload };
      })
      .addCase(assignScorer.pending, (state) => {
        state.assigningScorer = true;
      })
      .addCase(removeScorer.fulfilled, (state, action) => {
        state.removingScorer = false;
      })
      .addCase(removeScorer.rejected, (state, action) => {
        state.removingScorer = false;
        state.error = action.payload;
      })
      .addCase(removeScorer.pending, (state) => {
        state.removingScorer = true;
      })
      .addCase(saveScorecardPhoto.fulfilled, (state, action) => {
        state.savingScorecardPhoto = false;
      })
      .addCase(saveScorecardPhoto.rejected, (state, action) => {
        state.savingScorecardPhoto = false;
        state.error = action.payload;
      })
      .addCase(saveScorecardPhoto.pending, (state) => {
        state.savingScorecardPhoto = true;
      })
      .addCase(generateGames12LogBased.fulfilled, (state, action) => {
        state.generatingGames = false;
        //state.games = state.games.concat(action.payload);
      })
      .addCase(generateGames12LogBased.rejected, (state, action) => {
        state.generatingGames = false;
        state.error = action.payload;
      })
      .addCase(generateGames12LogBased.pending, (state) => {
        state.generatingGames = true;
      });
  }
});

export default gameSlice.reducer;
